import { render, staticRenderFns } from "./PageSimilarity.pug?vue&type=template&id=72c61f5f&lang=pug&external"
import script from "./PageSimilarity.js?vue&type=script&lang=js&external"
export * from "./PageSimilarity.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports